
import { Box, Chip, Typography, useTheme } from '@mui/material';
import React from 'react'
import { dollarFormatter } from '../utils';
import { ReceiptItem } from '../models';
const SplitReceiptDisplay: React.FC<{
  getCustomerItemMapping: () => { [key: string]: ReceiptItem[]; };
  getCustomerTotal: (customerItems: ReceiptItem[]) => number;
}> = ({ getCustomerItemMapping, getCustomerTotal }) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '90%',
      }}
    >
      {Object.entries(getCustomerItemMapping()).map(
        ([customerName, customerItems]: [string, ReceiptItem[]], index) => {
          return (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                gap: '16px',
                width: '100%',
                padding: '16px 8px',
                backgroundColor:
                  index % 2 === 0 ? theme.palette.primary.light : 'none',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  width: '100%',
                }}
              >
                <Chip label={`${index + 1}`} />
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography variant='body1'>{`${customerName}`}</Typography>
                  <Typography variant='body1'>
                    {`${dollarFormatter(getCustomerTotal(customerItems))}`}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  gap: '8px',
                }}
              >
                <Chip
                  size='small'
                  label={
                    <Typography variant='subtitle1'>Shared Items:</Typography>
                  }
                />
                <Typography variant='subtitle1'>
                  {`${customerItems.map((item) => item.name).join(', ')}`}
                </Typography>
              </Box>
            </Box>
          );
        },
      )}
    </Box>
  );
};

export default SplitReceiptDisplay